import UnavailableMethodException from '@naturehouse/nh-essentials/lib/exceptions/UnavailableMethodException';
import type HttpError from '@naturehouse/nh-essentials/lib/requests/HttpError';
import CollectionBase from '../../common/CollectionBase';
import { PeriodStorageCollectionType } from '../app/PeriodStorageManager';
import type { BasePeriodCollectionParamsType } from './BasePeriodCollectionParams.type';
import type { PeriodConfigurationCollectionDataType } from './PeriodConfigurationCollection';

export type PeriodConfigurationV2CollectionParamsType = BasePeriodCollectionParamsType & {
    periodConfigurationId?: string;
};

export type PeriodConfigurationV2ResponseType = PeriodConfigurationCollectionDataType & {
    id: number;
};

export default class PeriodConfigurationV2Collection extends CollectionBase<
    PeriodConfigurationCollectionDataType,
    PeriodConfigurationV2CollectionParamsType
> {
    protected name = PeriodStorageCollectionType.CONFIGURATION;

    static #instance: PeriodConfigurationV2Collection | null = null;

    public static getInstance(): PeriodConfigurationV2Collection {
        if (this.#instance === null) {
            this.#instance = new PeriodConfigurationV2Collection();
        }

        return this.#instance;
    }

    public add<RT = PeriodConfigurationV2ResponseType>(
        data: PeriodConfigurationCollectionDataType,
        params: PeriodConfigurationV2CollectionParamsType
    ): Promise<RT | void> {
        return super.add<RT>(data, params);
    }

    public async update<RT = PeriodConfigurationV2ResponseType>(
        data: PeriodConfigurationCollectionDataType,
        params: PeriodConfigurationV2CollectionParamsType
    ): Promise<RT | void> {
        return super.update<RT>(data, params);
    }

    public async retrieve(): Promise<void> {
        throw new UnavailableMethodException();
    }

    public async delete(): Promise<void> {
        throw new UnavailableMethodException();
    }

    protected endpoint(params?: PeriodConfigurationV2CollectionParamsType): string {
        if (!params || !params.houseId) {
            throw new Error('houseId is required');
        }

        return `/api/v2/houses/${params.houseId}/periods/configurations`;
    }

    protected updateEndpoint(params?: PeriodConfigurationV2CollectionParamsType): string {
        if (!params || !params.houseId || !params.periodConfigurationId) {
            throw new Error('houseId & periodConfigurationId are required');
        }

        return `${this.endpoint(params)}/${params.periodConfigurationId}`;
    }

    protected onError(error: HttpError<AjaxResponseError>): void {
        const body = error.body as AjaxResponse | undefined;

        throw new Error(body?.errors?.[0]?.message ?? body?.message);
    }
}
